const regionalManagement = {
  en: {
    regionalManagementPage: {
      statuses: { approved: "approved", pending: "pending", rejected: "rejected", certified: "certified" },
      title: "Regional Elections Management",
      subtitle: "North-West & South-West Regions Only",
      shareTitle: "EReMS Cameroon - Regional Election Results",
      shareText: "🗳️ Regional Elections for North-West & South-West Cameroon!",
      refresh: "Refresh",
      unknown: "Unknown",
      banner: {
        title: "Special Status Regions",
        text: "Regional elections apply only to North-West and South-West regions with special status under the 2019 decentralization law."
      },
      northWest: "North-West",
      southWest: "South-West",
      stats: {
        regions: "Regions",
        totalVotes: "Total Votes",
        validVotes: "Valid Votes",
        rejectedVotes: "Rejected Votes"
      },
      tabs: {
        overview: "Overview",
        results: "Results ({{count}})",
        northWest: "North-West ({{count}})",
        southWest: "South-West ({{count}})"
      },
      overview: {
        partyResults: "Party Results",
        noResults: "No results yet",
        voteDistribution: "Vote Distribution",
        noData: "No data"
      },
      resultsTab: {
        title: "Election Results",
        submitted: "{{division}} • Submitted {{date}}",
        validCount: "{{count}} valid",
        none: "No results submitted"
      },
      candidatesTab: {
        northWestTitle: "North-West Region Candidates",
        southWestTitle: "South-West Region Candidates",
        noneNorthWest: "No candidates registered for North-West",
        noneSouthWest: "No candidates registered for South-West"
      }
    }
  },
  fr: {
    regionalManagementPage: {
      statuses: { approved: "approuvé", pending: "en attente", rejected: "rejeté", certified: "certifié" },
      title: "Gestion des élections régionales",
      subtitle: "Régions du Nord-Ouest et du Sud-Ouest uniquement",
      shareTitle: "EReMS Cameroon - Résultats des élections régionales",
      shareText: "🗳️ Élections régionales dans le Nord-Ouest et le Sud-Ouest du Cameroun !",
      refresh: "Actualiser",
      unknown: "Inconnu",
      banner: {
        title: "Régions à statut spécial",
        text: "Les élections régionales ne concernent que les régions du Nord-Ouest et du Sud-Ouest, dotées d'un statut spécial en vertu de la loi de 2019 sur la décentralisation."
      },
      northWest: "Nord-Ouest",
      southWest: "Sud-Ouest",
      stats: {
        regions: "Régions",
        totalVotes: "Total des votes",
        validVotes: "Votes valides",
        rejectedVotes: "Votes rejetés"
      },
      tabs: {
        overview: "Aperçu",
        results: "Résultats ({{count}})",
        northWest: "Nord-Ouest ({{count}})",
        southWest: "Sud-Ouest ({{count}})"
      },
      overview: {
        partyResults: "Résultats par parti",
        noResults: "Aucun résultat pour le moment",
        voteDistribution: "Répartition des voix",
        noData: "Aucune donnée"
      },
      resultsTab: {
        title: "Résultats des élections",
        submitted: "{{division}} • Soumis le {{date}}",
        validCount: "{{count}} valides",
        none: "Aucun résultat soumis"
      },
      candidatesTab: {
        northWestTitle: "Candidats de la région du Nord-Ouest",
        southWestTitle: "Candidats de la région du Sud-Ouest",
        noneNorthWest: "Aucun candidat enregistré pour le Nord-Ouest",
        noneSouthWest: "Aucun candidat enregistré pour le Sud-Ouest"
      }
    }
  }
};

export default regionalManagement;
